module.exports = __webpack_public_path__ + "fonts/3a46542f-f429-4821-9a88-62e3be54a640.9b36197.woff2";